(()=>{'use strict';
if(customElements.get('cmc-weirdos-storefront'))return;
customElements.define('cmc-weirdos-storefront',class extends HTMLElement{
  connectedCallback(){
    if(this.initialized)return;
    this.initialized=true;
    const filters=this.querySelector('.cw-filters');
    if(filters)filters.hidden=false;
    const applyBrand=key=>{
      const filterKey=key==='halloween'?'weirdos':key;
      this.dataset.mode=(filterKey==='weirdos')?'weirdos':filterKey;
      this.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x.dataset.filter===filterKey)));
      this.querySelectorAll('[data-brand-only]').forEach(x=>x.hidden=x.dataset.brandOnly!==filterKey);
      const cards=[...this.querySelectorAll('[data-brand]')];
      cards.forEach(x=>x.hidden=filterKey!=='all'&&x.dataset.brand!==filterKey);
      this.querySelector('[data-filter-empty]').hidden=!cards.length||cards.some(x=>!x.hidden);
    };
    this.addEventListener('click',event=>{
      const color=event.target.closest('[data-color-src]');
      if(color&&this.contains(color)){
        const group=color.closest('.cw-color-switch'),image=this.querySelector('#'+CSS.escape(color.dataset.card));
        group.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',String(x===color)));
        if(image)image.src=color.dataset.colorSrc;
        return;
      }
      const button=event.target.closest('[data-filter],[data-shop-brand],[data-entry-brand]');
      if(!button||!this.contains(button))return;
      const key=button.dataset.filter||button.dataset.shopBrand||button.dataset.entryBrand;
      applyBrand(key);
      const href=button.getAttribute('href');
      if(href&&href.startsWith('#')){
        event.preventDefault();
        const target=this.querySelector(href);
        if(target){
          target.setAttribute('tabindex','-1');
          target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
          target.focus({preventScroll:true});
        }
      }
    });
    this.addEventListener('change',event=>{
      const select=event.target.closest('[data-variant-select]');
      if(!select)return;
      const option=select.selectedOptions[0],card=select.closest('.cw-product'),button=card.querySelector('[data-add-button]');
      card.querySelector('[data-variant-price]').textContent=option.dataset.price;
      button.disabled=option.dataset.available!=='true';
      button.textContent=button.disabled?button.dataset.labelSold:button.dataset.labelAdd;
    });
  }
});
})();
